module.exports = function() {
  return new Worker(__webpack_public_path__ + "02f0ccf145e2da1bb858.worker.js");
};